import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";


const routes = [
  {
    path: '/login',
    name: '登录',
    component: () => import('../viwes/Login/Login'),
    meta: { requireAuth: true },
    children: []
  },
  {
    path: '/newdata',
    name: '营业数据',
    component: () => import('../viwes/Data/NewData'),
    meta: { requireAuth: true },
    children: []
  },
  {
    path: '/',
    name: '',
    component: () => import('../viwes/Index/Index'),
    meta: { requireAuth: true },
    children: [
      {
        path: '/user/list',
        name: '用户列表',
        component: () => import('../viwes/User/List'),
        meta: { requireAuth: true },
        children: []
      },

      {
        path: '/user/salesman',
        name: '銷售列表',
        component: () => import('../viwes/User/Salesman'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/user/forminfo',
        name: '表單信息',
        component: () => import('../viwes/User/Forminfo'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/system/menus',
        name: '菜单管理',
        component: () => import('../viwes/SystemMange/menus'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/merchant/list',
        name: '商户列表',
        component: () => import('../viwes/Merchant/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/merchant/examine',
        name: '等待审核',
        component: () => import('../viwes/Merchant/Examine'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/goods/list',
        name: '商品列表',
        component: () => import('../viwes/Goods/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/orders/list',
        name: '订单列表',
        component: () => import('../viwes/Orders/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/finance/list',
        name: '财务列表',
        component: () => import('../viwes/Finance/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/new/list',
        name: '新闻管理',
        component: () => import('../viwes/New/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/type/list',
        name: '分类管理',
        component: () => import('../viwes/Type/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/config/peicon',
        name: 'APP配置',
        component: () => import('../viwes/Config/PeiConfig'),
        meta: { requireAuth: true },
        children: []
      },

      {
        path: '/config/privacy',
        name: '协议列表',
        component: () => import('../viwes/Config/PrivacyPolicyList'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/config/notice',
        name: '首頁彈窗',
        component: () => import('../viwes/Config/Notice'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/config/slideshow',
        name: '首頁輪播',
        component: () => import('../viwes/Config/slideshow'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/account/index',
        name: '賬號管理',
        component: () => import('../viwes/SystemMange/account'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/authority/index',
        name: '權限管理',
        component: () => import('../viwes/SystemMange/authority'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/port/index',
        name: '接口管理',
        component: () => import('../viwes/SystemMange/port'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/account/pwd',
        name: '修改密碼',
        component: () => import('../viwes/SystemMange/changePwd'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/goods/coupon',
        name: '优惠卷',
        component: () => import('../viwes/Goods/Coupon'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/pay/list',
        name: '支付管理',
        component: () => import('../viwes/Pay/List'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/chat/chat',
        name: '客服中心',
        component: () => import('../viwes/Chat/chat'),
        meta: { requireAuth: true },
        children: []
      },

    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;